
import React from 'react';
import { BasicInfoSection } from '../../../addBusinessModal';
import { FormSection } from '../';
// import { BusinessDetails } from '../../../addBusinessModal/types'; // No longer needed directly
import { useBusinessFormContext } from '@/context/BusinessFormContext';

// Props for BasicInfoFormSection will be empty as all data comes from context
interface BasicInfoFormSectionProps {}

const BasicInfoFormSection: React.FC<BasicInfoFormSectionProps> = () => {
  const {
    businessDetails,
    handleInputChange,
    handleSelectChange,
    selectedDate,
    calendarOpen,
    setCalendarOpen,
    handleDateSelect,
    shortNameManuallyEdited, // From context
    // setShortNameManuallyEdited, // From context, BasicInfoSection might call it if it has focus/blur logic for shortName
    handleWebsiteBlur,
    basicInfoOpen,
    setBasicInfoOpen,
    basicInfoComplete,
    basicInfoEdited,
    basicInfoHasChanges,
    saveBasicInfo,
    errors,
    isSavingBasicInfo, // Get loading state from context
  } = useBusinessFormContext();

  // Calculate derived values internally
  const nameExceeds30Chars = businessDetails.name ? businessDetails.name.length > 30 : false;
  const shortNameLength = businessDetails.shortName ? businessDetails.shortName.length : 0;

  // The prop `isCompleted` for `FormSection` was previously `basicInfoEdited`.
  // This implies "completed" in the sense of "has been submitted/saved at least once".
  // The context provides `basicInfoEdited` for this.
  // The context also provides `basicInfoComplete` for "all required fields are validly filled".
  // We need to ensure `FormSection` uses these appropriately.
  // Assuming `FormSection`'s `isCompleted` prop is for the "saved/submitted" state,
  // and `isComplete` prop is for "validation complete".

  return (
    <FormSection
      number={1}
      title="General Info"
      open={basicInfoOpen}
      onOpenChange={setBasicInfoOpen}
      isCompleted={basicInfoEdited} // Represents if the section has been saved/processed at least once
      isDisabled={false} // This section is never disabled initially
      isComplete={basicInfoComplete} // Represents if all required fields are valid
      isEdited={basicInfoEdited} // Redundant if isCompleted serves the same purpose, but keeping if FormSection uses it distinctly
      hasUnsavedChanges={basicInfoHasChanges}
      onSave={saveBasicInfo}
      isProcessing={isSavingBasicInfo} // Pass loading state to FormSection
    >
      <BasicInfoSection
        businessDetails={businessDetails}
        handleInputChange={handleInputChange}
        handleSelectChange={handleSelectChange}
        selectedDate={selectedDate}
        calendarOpen={calendarOpen}
        setCalendarOpen={setCalendarOpen}
        handleDateSelect={handleDateSelect}
        nameExceeds30Chars={nameExceeds30Chars}
        shortNameLength={shortNameLength}
        shortNameManuallyEdited={shortNameManuallyEdited}
        handleWebsiteBlur={handleWebsiteBlur}
        errors={errors}
        // Note: BasicInfoSection might need its own internal logic or props for setShortNameManuallyEdited
        // if it directly handles the edit state of the short name field.
        // For now, we pass shortNameManuallyEdited from context.
      />
    </FormSection>
  );
};

export default BasicInfoFormSection;
